<template>
  <el-container style="width: 100%; height: 100%;">
    <lx-navigator nav-title="考核设置" nav-active="1-1" :menuItems="menuItems"></lx-navigator>
    <el-main style="padding: 0 10px; height: 100%; font-size: 14px;">
      <lx-step-bar :step-first="stepName" step-second="考核设置">
      </lx-step-bar>
      <el-row style="height: calc( 100% - 60px); background-color: #fff; margin-top: 10px; overflow: auto;">
        <el-col style="padding: 10px;">
          <el-row class="lx-right-sub-title">
            <el-col :span="20"><i></i>当前总分：{{totalScore}}分</el-col>
          </el-row>

          <el-row style="padding: 20px 10px;">
            <el-col>
              <el-table
                :data="formData"
                border
                class="lx-table" row-class-name="lx-table-row" header-cell-class-name="lx-table-header-cell" cell-class-name="lx-table-cell"
                style="width: 100%;">
                <el-table-column prop="name" label="步骤名称" width="180" align="center"></el-table-column>
                <el-table-column prop="resource.name" label="资源名称" width="180" align="center"></el-table-column>
                <el-table-column label="资源类型" width="100" align="center">模型</el-table-column>
                <el-table-column label="试题">
                  <template slot-scope="scope">
                    <el-tag  style="background-color: #F7F7F7; border-color: #DDDDDD; color: #63666f; margin-right: 10px;"
                             type="info" v-for="(list, index) in scope.row.questions" :key="index" closable :disable-transitions="false" @close="deleteQuestion(list)">
                      {{ '第' + (index + 1) + '题' + '（' + list.score + '分）' }}
                      <i class="el-icon-edit" @click="editQuestion(list, scope.row.id)"></i>
                    </el-tag>
                    <el-tag style="border-style: dashed; background-color: transparent; color: #63666f;border-color: #dddddd; cursor: pointer; "  @click.native="addQuestion(scope.row)">+添加</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="resourceNo" label="动画序列号" width="100" align="center"></el-table-column>
                <el-table-column prop="processOrder" label="显示顺序" width="100" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-main>
    <check-question-editor :visible.sync="quesEditorVisible"
                            :question="question"
                            :questionId="questionId"
                            :processLineId="processLineId"
                            :editText="editText"
                            @success-result="successResult"
                            @close-dialog="closeDialog">
    </check-question-editor>
  </el-container>
</template>
<script>
import Navigator from '@/components/common/Navigator'
import StepBar from '@/components/common/StepBar'
import CheckQuestionEditor from '@/components/check/CheckQuestionEditor'
export default {
  components: { 'lx-navigator': Navigator, 'lx-step-bar': StepBar, 'check-question-editor': CheckQuestionEditor },
  data () {
    return {
      menuItems: [
        { index: '1-1', name: '考核设置', route: {name: 'EngineCheckSetting'} }
      ],
      nowIndex: 0,
      totalScore: 10,
      formData: [],
      quesEditorVisible: false,
      editText: '添加',
      question: {},
      questionId: null,
      processLineId: null
    }
  },
  mounted () {
    this.initData()
  },
  computed: {
    stepName () {
      let checkName = sessionStorage.getItem('check')
      let showName = ''
      switch (checkName) {
        case 'EngineCheckSetting': showName = '发动机拆装与检查'; break
        case 'CylinderlCheckSetting': showName = '气缸的测量'; break
        case 'CrankshaftCheckSetting': showName = '曲轴的测量'; break
        case 'TransmissionCheckSetting': showName = '变速器同步器'; break
        default: showName = '发动机拆装与检查'
      }
      return showName
    }
  },
  methods: {
    initData () {
      this.$xhrGet(`/checks/${sessionStorage.getItem('recordId')}/details`).then(rs => {
        if (rs.code === 200) {
          this.totalScore = rs.data.score
          this.formData = rs.data.processLines
        }
      })
    },
    deleteQuestion (row) {
      this.$xhrPatch(`/checks/${sessionStorage.getItem('recordId')}/questions/${row.questionId}`).then(rs => {
        if (rs.code === 200) {
          this.$message.success('删除试题成功！')
          this.initData()
        }
      })
    },
    editQuestion (row, resourceId) {
      this.question = row
      this.questionId = row.id
      this.processLineId = resourceId
      this.editText = '编辑'
      this.quesEditorVisible = true
    },
    addQuestion (row) {
      this.editText = '添加'
      this.processLineId = row.id
      this.quesEditorVisible = true
    },
    closeDialog () {
      this.quesEditorVisible = false
    },
    successResult () {
      this.quesEditorVisible = false
      this.initData()
    }
  }
}
</script>

<style scoped lang="scss">
div, p { box-sizing: border-box; }
.el-tag--info /deep/ {
  .el-icon-edit {
    border-radius: 50%;
    text-align: center;
    position: relative;
    cursor: pointer;
    font-size: 12px;
    height: 16px;
    width: 16px;
    line-height: 16px;
    vertical-align: middle;
    top: -1px;
    right: -5px;
  }
}
.el-tag--info /deep/ {
  .el-icon-edit:hover {
    background-color: #909399;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/check/CheckSetting.vue